// @ts-nocheck
/**
 * カテゴリ・派閥グループ定義
 * equipment_effect_definitions.md に基づく
 *
 * category_boost / faction_boost の対象グループを定義
 *
 * @module twinKey/data/categoryGroups
 */

// ============================================================
// 種族系グループ（13種）
// ============================================================

export const CATEGORY_GROUPS = {
  'ドラゴン系': ['ドラゴン', 'ワイバーン', 'サラマンダー'],
  'ビースト系': [
    'ビースト',
    'ビースト・猫',
    'ビースト・狸',
    'ビースト・狼',
    'ビースト・フロッグ',
    'ビースト・鹿',
    'ビースト・イノシシ',
    '幻獣',
  ],
  'スピリット': ['スピリット'],
  '鳥系': ['鳥', '鳥・カラス', '鳥・カモメ'],
  'ゴーレム系': ['ゴーレム', 'ガーディアン'],
  'プラント系': ['プラント'],
  'スライム系': ['スライム', 'コア・ビースト'],
  '虫類': [
    'インセクト',
    'インセクト・アリ',
    'インセクト・ビートル',
    'インセクト・蜘蛛',
    'インセクト・蛾',
    'インセクト・アメンボ',
  ],
  '機械': ['マシン'],
  '魔法生物': ['魔族', '魔導士', 'ウィザード'],
  '霊体': ['ゴースト', 'スケルトン'],
  '爬虫類': ['スネーク'],
  'ヒューマノイド': ['ヒューマノイド', 'カイザー', 'ソルジャー'],
};

// ============================================================
// 派閥系グループ（15種）
// ============================================================

export const FACTION_GROUPS = {
  'ソウルカース': ['ソウルカース'],
  'タイドウェーブ': ['タイドウェーブ', 'マーメイド', 'リヴァイアサン'],
  'パペットマスター': ['パペットマスター'],
  'ダークドウェラ': ['ダークドウェラ', 'シャドウ'],
  'マグマフォージ': ['マグマフォージ'],
  '蛮族': ['蛮族'],
  'エクラシア': ['エクラシア', 'プリンセス'],
  '飛翔連合': ['スカイレジェンド', 'ウィング・トリビューン', 'フェニックス'],
  '深淵勢力': ['アビスソウル', 'ディープシャドウ', 'デーモン', 'ブラック・オラクル'],
  '虚蝕': ['虚蝕'],
  '聖光': ['ルミナフォース', '天使', 'エンジェル'],
  '時空': ['トラベラー'],
  '毒牙': ['ポイズンウェイル'],
  '拘束': ['鎖'],
  '宿敵': ['ライバル'],
};

// ============================================================
// ヘルパー関数
// ============================================================

/**
 * モンスターのカテゴリがグループに属するか判定
 * @param {string} monsterCategory - モンスターのカテゴリ（例: "【ドラゴン】【炎】"）
 * @param {string} groupName - グループ名（例: "ドラゴン系"）
 * @returns {boolean}
 */
export function isCategoryInGroup(monsterCategory, groupName) {
  if (!monsterCategory || !groupName) return false;

  const group = CATEGORY_GROUPS[groupName];
  if (!group) return false;

  // カテゴリ文字列から【】を抽出
  const categories = extractCategories(monsterCategory);

  // グループ内のいずれかのカテゴリを持っているかチェック
  return categories.some((cat) => group.includes(cat));
}

/**
 * モンスターのカテゴリが派閥グループに属するか判定
 * @param {string} monsterCategory - モンスターのカテゴリ
 * @param {string} factionName - 派閥名（例: "飛翔連合"）
 * @returns {boolean}
 */
export function isFactionInGroup(monsterCategory, factionName) {
  if (!monsterCategory || !factionName) return false;

  const group = FACTION_GROUPS[factionName];
  if (!group) return false;

  const categories = extractCategories(monsterCategory);
  return categories.some((cat) => group.includes(cat));
}

/**
 * カテゴリ文字列から個々のカテゴリを抽出
 * @param {string} categoryStr - カテゴリ文字列（例: "【ドラゴン】【炎】"）
 * @returns {string[]} カテゴリ配列
 */
export function extractCategories(categoryStr) {
  if (!categoryStr || typeof categoryStr !== 'string') return [];

  const matches = categoryStr.match(/【([^】]+)】/g) || [];
  return matches.map((m) => m.replace(/[【】]/g, ''));
}

/**
 * 全グループ名を取得
 * @returns {{ categories: string[], factions: string[] }}
 */
export function getAllGroupNames() {
  return {
    categories: Object.keys(CATEGORY_GROUPS),
    factions: Object.keys(FACTION_GROUPS),
  };
}
